<!-- Start Breadcrumbs -->
<app-breadcrumbs title="{{('t-m-properties.t-properties' | translate)}}"
  [breadcrumbItems]="[{ label: ('t-m-properties.t-properties' | translate) },{ label: ('t-list' | translate), active: true }]"
  *ngIf="!portalExportError?.status">
</app-breadcrumbs>
<!-- End Breadcrumbs -->

<div class="row" *ngIf="openModaltSubject$.getValue()>= 5 && !openPreview">
  <div class="col-lg-12">
    <div class="card" id="leadsList">
      <div class="card-header border-0">
        <ul ngbNav #customNav="ngbNav" (activeIdChange)="changeTab($event)" [(activeId)]="nabTabActive"
          class="nav nav-tabs-custom rounded card-header-tabs border-bottom-0" role="tablist">
          <li [ngbNavItem]="1" class="nav-item">
            <a ngbNavLink class="nav-link">
              {{'t-properties' | translate }}
            </a>
            <ng-template ngbNavContent>
              <div class="card-body">
                <div class="properties-list-toolbar">
                  <div class="properties-toolbar-top">
                    <div class="properties-toolbar-search">
                      <div class="search-box" [class.placeholder-glow]="hideElement">
                        <input type="text" name="searchTerm" class="form-control"
                          [attr.placeholder]="!hideElement ? ('t-free-search-placeholder'|translate):''"
                          [formControl]="queryField" [class.placeholder]="hideElement"
                          [attr.disabled]="hideElement ? true: null">
                        <i class="ri-search-line search-icon" *ngIf="!hideElement"></i>
                      </div>
                      <div class="search-box reference-search-box" [class.placeholder-glow]="hideElement">
                        <input type="text" name="referenceSearchTerm" class="form-control"
                          [attr.placeholder]="!hideElement ? ('t-search-by-reference'|translate):''"
                          [formControl]="referenceQueryField" [class.placeholder]="hideElement"
                          [attr.disabled]="hideElement ? true: null">
                        <i class="ri-hashtag search-icon" *ngIf="!hideElement"></i>
                      </div>
                    </div>

                    <ng-container *ngIf="!portalExportError?.status">
                      <div class="properties-toolbar-actions" [class.placeholder-glow]="hideElement">
                        <button *ngIf="permissionsService.isRealMaster()" class="btn btn-soft-danger btn-icon"
                          (click)="deleteMultiple()" [class.placeholder]="hideElement"
                          [attr.disabled]="countCheckSelected==0 ? true: null" [ngbTooltip]="'t-delete' | translate"
                          container="body">
                          <i class="ri-delete-bin-2-line"></i>
                        </button>

                        <app-saved-property-filters *ngIf="propertiesFiltersForm" resource="PROPERTY"
                          [currentFilters]="propertyFilters" [currentFormValue]="currentSavedFilterFormValue"
                          [selectedStatusId]="selectedStatusId" [selectedScope]="selectedScope" [disabled]="hideElement"
                          [autoApplyDefault]="!isOpenModal" [appliedFilterId]="appliedSavedFilterId"
                          (apply)="applySavedPropertyFilter($event)">
                        </app-saved-property-filters>

                        <button *appHasPermission="'CREATE_PROPERTIES'" type="button" class="btn btn-primary add-btn"
                          id="create-btn" (click)="openModal()" [class.placeholder]="hideElement"
                          [attr.disabled]="hideElement ? true: null"><i class="ri-add-line align-bottom me-1"></i>
                          {{ 't-m-properties.t-add-property'| translate }}
                        </button>
                      </div>
                    </ng-container>
                  </div>

                  <div class="properties-toolbar-quick" *ngIf="!portalExportError?.status">
                    <div class="dropdown quick-filter-dropdown" *ngIf="statusList">
                      <button type="button" class="quick-filter-btn" [class.has-value]="hasStatusFilter"
                        data-bs-toggle="dropdown" data-bs-auto-close="outside">
                        <i class="ri-checkbox-circle-line"></i>
                        <span>{{ 't-m-properties.t-status' | translate }}</span>
                        <strong class="text-truncate">{{ statusFilterLabel }}</strong>
                        <i class="ri-arrow-down-s-line ms-auto"></i>
                      </button>
                      <div class="dropdown-menu quick-filter-menu">
                        <button type="button" class="quick-filter-option" *ngFor="let status of statusList"
                          [class.is-selected]="selectedStatusId === status.id" (click)="onChangestatus(status.id)">
                          <span>{{ status.description || status.name }}</span>
                          <i class="ri-check-line" *ngIf="selectedStatusId === status.id"></i>
                        </button>
                      </div>
                    </div>

                    <div class="dropdown quick-filter-dropdown" [formGroup]="propertiesFiltersForm"
                      *ngIf="propertiesFiltersForm">
                      <button type="button" class="quick-filter-btn" [class.has-value]="locationFilterLabel"
                        data-bs-toggle="dropdown" data-bs-auto-close="outside">
                        <i class="ri-map-pin-line"></i>
                        <span>{{ 't-m-properties.t-location' | translate }}</span>
                        <strong class="text-truncate" *ngIf="locationFilterLabel">{{ locationFilterLabel }}</strong>
                        <i class="ri-arrow-down-s-line ms-auto"></i>
                      </button>
                      <div class="dropdown-menu quick-filter-menu quick-filter-menu-xl">
                        <div class="quick-filter-cascade">
                          <div class="quick-filter-column">
                            <div class="quick-filter-column-header">
                              <span class="quick-filter-column-title">
                                <i class="ri-map-pin-line"></i>
                                {{ 't-m-properties.t-district' | translate }}
                              </span>
                              <small *ngIf="propertiesFiltersForm.get('district')?.value?.length">{{
                                propertiesFiltersForm.get('district')?.value?.length }}</small>
                            </div>
                            <div class="quick-filter-options">
                              <button type="button" class="quick-filter-option" *ngFor="let district of districts"
                                [class.is-selected]="isQuickFormArrayValueSelected('district', district.id)"
                                (click)="toggleQuickFormArrayValue('district', district.id)">
                                <span>{{ district.name }}</span>
                                <i class="ri-check-line"
                                  *ngIf="isQuickFormArrayValueSelected('district', district.id)"></i>
                              </button>
                            </div>
                          </div>

                          <div class="quick-filter-column">
                            <div class="quick-filter-column-header">
                              <span class="quick-filter-column-title">
                                <i class="ri-community-line"></i>
                                {{ 't-m-properties.t-county' | translate }}
                              </span>
                              <small *ngIf="propertiesFiltersForm.get('county')?.value?.length">{{
                                propertiesFiltersForm.get('county')?.value?.length }}</small>
                            </div>
                            <div class="quick-filter-options">
                              <button type="button" class="quick-filter-option" *ngFor="let county of counties"
                                [class.is-selected]="isQuickFormArrayValueSelected('county', county.id)"
                                (click)="toggleQuickFormArrayValue('county', county.id)">
                                <span>{{ county.name }}</span>
                                <i class="ri-check-line" *ngIf="isQuickFormArrayValueSelected('county', county.id)"></i>
                              </button>
                              <span class="quick-filter-empty-option" *ngIf="!counties?.length">---</span>
                            </div>
                          </div>

                          <div class="quick-filter-column">
                            <div class="quick-filter-column-header">
                              <span class="quick-filter-column-title">
                                <i class="ri-road-map-line"></i>
                                {{ 't-m-properties.t-parish' | translate }}
                              </span>
                              <small *ngIf="propertiesFiltersForm.get('parish')?.value?.length">{{
                                propertiesFiltersForm.get('parish')?.value?.length }}</small>
                            </div>
                            <div class="quick-filter-options">
                              <button type="button" class="quick-filter-option" *ngFor="let item of parish"
                                [class.is-selected]="isQuickFormArrayValueSelected('parish', item.id)"
                                (click)="toggleQuickFormArrayValue('parish', item.id)">
                                <span>{{ item.name }}</span>
                                <i class="ri-check-line" *ngIf="isQuickFormArrayValueSelected('parish', item.id)"></i>
                              </button>
                              <span class="quick-filter-empty-option" *ngIf="!parish?.length">---</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="dropdown quick-filter-dropdown" [formGroup]="propertiesFiltersForm"
                      *ngIf="propertiesFiltersForm">
                      <button type="button" class="quick-filter-btn"
                        [class.has-value]="propertiesFiltersForm.get('typology')?.value?.length"
                        data-bs-toggle="dropdown" data-bs-auto-close="outside">
                        <i class="ri-layout-grid-line"></i>
                        <span>{{ 't-typology' | translate }}</span>
                        <strong class="text-truncate" *ngIf="typologyFilterLabel">{{ typologyFilterLabel }}</strong>
                        <i class="ri-arrow-down-s-line ms-auto"></i>
                      </button>
                      <div class="dropdown-menu quick-filter-menu">
                        <div class="quick-filter-options">
                          <button type="button" class="quick-filter-option" *ngFor="let typology of typologies"
                            [class.is-selected]="isQuickFormArrayValueSelected('typology', typology.id)"
                            (click)="toggleQuickFormArrayValue('typology', typology.id)">
                            <span>{{ typology.name }}</span>
                            <i class="ri-check-line" *ngIf="isQuickFormArrayValueSelected('typology', typology.id)"></i>
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="dropdown quick-filter-dropdown" [formGroup]="propertiesFiltersForm"
                      *ngIf="propertiesFiltersForm">
                      <button type="button" class="quick-filter-btn"
                        [class.has-value]="propertiesFiltersForm.get('propertyTypes')?.value?.length"
                        data-bs-toggle="dropdown" data-bs-auto-close="outside">
                        <i class="ri-home-4-line"></i>
                        <span>{{ 't-m-properties.t-property-type' | translate }}</span>
                        <strong class="text-truncate" *ngIf="propertyTypeFilterLabel">{{ propertyTypeFilterLabel }}</strong>
                        <i class="ri-arrow-down-s-line ms-auto"></i>
                      </button>
                      <div class="dropdown-menu quick-filter-menu quick-filter-menu-lg quick-filter-property-menu">
                        <div class="quick-filter-type-groups">
                          <div class="quick-filter-type-group" *ngFor="let group of getPropertyTypeGroups()">
                            <button type="button" class="quick-filter-type-header"
                            [class.is-selected]="isPropertyTypeGroupSelected(group)"
                            (click)="onQuickPropertyTypeGroupClick($event, group)">
                              <span class="quick-filter-type-title">
                                <i class="ri-folder-3-line"></i>
                                <span>{{ group.name }}</span>
                              </span>
                              <small>{{ getPropertyTypeGroupSelectedCount(group) }}/{{ group.items.length }}</small>
                            </button>
                            <div class="quick-filter-subtype-list">
                              <button type="button" class="quick-filter-option quick-filter-subtype-option"
                              *ngFor="let type of group.items"
                              [class.is-selected]="isQuickFormArrayValueSelected('propertyTypes', type.id)"
                              (click)="onQuickFormArrayValueClick($event, 'propertyTypes', type.id)">
                                <span>{{ type.description }}</span>
                                <i class="ri-check-line"
                                *ngIf="isQuickFormArrayValueSelected('propertyTypes', type.id)"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="quick-filter-switch" [class.has-value]="propertyFilters.hideUnits === true">
                      <div class="form-check form-switch form-switch-primary form-switch-md mb-0">
                        <input class="form-check-input" [checked]="propertyFilters.hideUnits === true"
                          (change)="changeHideUnits($event)" type="checkbox" role="switch" id="SwitchCheckUnits">
                        <label container="body" class="form-check-label" for="SwitchCheckUnits">
                          <i class="ri-eye-off-line"></i>
                          {{ (propertyFilters.hideUnits === true ? 't-developments.t-show-units' :
                          't-developments.t-hide-units') | translate }}
                        </label>
                      </div>
                    </div>

                    <div class="quick-filter-switch" *ngIf="showMinCommissionPendingFilter"
                      [class.has-value]="propertyFilters.minimumCommissionPendingValidation === true">
                      <div class="form-check form-switch form-switch-primary form-switch-md mb-0">
                        <input class="form-check-input"
                          [checked]="propertyFilters.minimumCommissionPendingValidation === true"
                          (change)="changeMinCommissionPending($event)" type="checkbox" role="switch"
                          id="SwitchCheckMinCommission">
                        <label container="body" class="form-check-label" for="SwitchCheckMinCommission">
                          <i class="ri-percent-line"></i>
                          {{ 't-developments.t-commission-to-validate' | translate }}
                        </label>
                      </div>
                    </div>

                    <div class="quick-filter-switch" *ngIf="showOutdatedParishFilter"
                      [class.has-value]="propertyFilters.outdatedParish === true">
                      <div class="form-check form-switch form-switch-primary form-switch-md mb-0">
                        <input class="form-check-input"
                          [checked]="propertyFilters.outdatedParish === true"
                          (change)="changeOutdatedParish($event)" type="checkbox" role="switch"
                          id="SwitchCheckOutdatedParish">
                        <label container="body" class="form-check-label" for="SwitchCheckOutdatedParish">
                          <i class="ri-map-pin-time-line"></i>
                          {{ 't-property-quick-filters.t-outdated-parishes' | translate }}
                        </label>
                      </div>
                    </div>

                    <button type="button" class="btn btn-light properties-more-filters" data-bs-toggle="offcanvas"
                      href="#offcanvasExample" (click)="showPropertyFilerts = true; openFilters()">
                      <i class="ri-filter-3-line align-bottom me-1"></i>
                      {{ 't-property-quick-filters.t-advanced'| translate }}
                      <span class="badge ms-1 border">{{countFilters$.getValue()}}</span>
                    </button>
                  </div>

                  <div class="properties-active-filters" *ngIf="activeFilterChips.length > 0">
                    <span class="active-filters-label">{{ 't-property-quick-filters.t-active' | translate }}:</span>
                    <button type="button" class="active-filter-chip" *ngFor="let chip of activeFilterChips"
                      (click)="removeActiveFilter(chip)">
                      <i [class]="chip.icon"></i>
                      <span>{{ chip.label }}</span>
                      <i class="ri-close-line"></i>
                    </button>
                    <button type="button" class="btn btn-link btn-sm p-0 active-filters-clear"
                      (click)="clearAllActiveFilters()">
                      {{ 't-clear-filter' | translate }}
                    </button>
                  </div>
                </div>

                <div class="table-card gridjs-border-none mt-3">
                  <div class="table-responsive" *ngIf="properties && total>0">
                    <table class="table align-middle mb-0">
                      <thead>
                        <tr class="bg-light text-muted">
                          <th scope="col" class="text-center" *ngIf="!portalExportError?.status" style="width:48px;">
                            <div class="form-check m-0 d-flex justify-content-center">
                              <input id="checkAll" class="form-check-input" type="checkbox" [(ngModel)]="masterSelected"
                                (change)="checkUncheckAll(true)" />
                            </div>
                          </th>

                          <th scope="col" class="text-nowrap" style="width:30%">
                            {{ 't-m-properties.t-property'| translate }}
                          </th>
                          <th scope="col" class="text-nowrap">
                            <button type="button" class="btn btn-link p-0 text-decoration-none text-reset text-nowrap"
                              (click)="onSort('propertyType')">
                              {{ 't-m-properties.t-property-type'| translate }}
                              <span class="ms-1">{{ getSortIndicator('propertyType') }}</span>
                            </button>
                          </th>
                          <th scope="col" class="text-nowrap">
                            <button type="button" class="btn btn-link p-0 text-decoration-none text-reset text-nowrap"
                              (click)="onSort('businessType')">
                              {{ 't-m-properties.t-business-type'| translate }}
                              <span class="ms-1">{{ getSortIndicator('businessType') }}</span>
                            </button>
                          </th>
                          <th scope="col" class="text-nowrap">
                            <button type="button" class="btn btn-link p-0 text-decoration-none text-reset text-nowrap"
                              (click)="onSort('price')">
                              {{ 't-m-properties.t-price'| translate }}
                              <span class="ms-1">{{ getSortIndicator('price') }}</span>
                            </button>
                          </th>
                          <th scope="col" class="text-nowrap">
                            <button type="button" class="btn btn-link p-0 text-decoration-none text-reset text-nowrap"
                              (click)="onSort('store')">
                              {{ 't-m-properties.t-store'| translate }}
                              <span class="ms-1">{{ getSortIndicator('store') }}</span>
                            </button>
                          </th>
                          <th scope="col" class="text-nowrap">
                            <button type="button" class="btn btn-link p-0 text-decoration-none text-reset text-nowrap"
                              (click)="onSort('status')">
                              {{ 't-m-properties.t-status'| translate }}
                              <span class="ms-1">{{ getSortIndicator('status') }}</span>
                            </button>
                          </th>
                          <th scope="col" class="text-nowrap">
                            <button type="button" class="btn btn-link p-0 text-decoration-none text-reset text-nowrap"
                              (click)="onSort('updated')">
                              {{ 't-m-properties.t-updated-at'| translate }}
                              <span class="ms-1">{{ getSortIndicator('updated') }}</span>
                            </button>
                          </th>
                          <th scope="col" class="text-nowrap">
                            <button type="button" class="btn btn-link p-0 text-decoration-none text-reset text-nowrap"
                              (click)="onSort('createdAt')">
                              {{ 't-created-at'| translate }}
                              <span class="ms-1">{{ getSortIndicator('createdAt') }}</span>
                            </button>
                          </th>
                          <th scope="col" class="text-end text-nowrap" style="width:120px">{{'t-action' | translate}}
                          </th>
                        </tr>
                      </thead>

                      <!-- LISTAGEM NORMAL -->
                      <tbody *ngIf="!propertyFilters.highlight" class="placeholder-glow-2">
                        <ng-container *ngFor="let property of properties">
                          <tr class="tr-n-border">
                            <!-- Checkbox -->
                            <td class="text-center" *ngIf="!portalExportError?.status" style="width:48px;">
                              <div class="form-check m-0 d-flex justify-content-center">
                                <input class="form-check-input" type="checkbox" name="checkAll"
                                  [(ngModel)]="property.isSelected" (change)="checkUncheckAll(false)"
                                  [disabled]="property?.isProcessing" />
                              </div>
                            </td>

                            <!-- Coluna: Property + imagem + referência + status -->
                            <td (click)="!property?.isProcessing ? openPreviewModal(modalPreview, property) : false"
                              [ngClass]="{'cursor-pointer':!property?.isProcessing}">
                              <div class="d-flex align-items-center">
                                <div class="flex-shrink-0 me-3" [ngClass]="{'placeholder-2':property?.isProcessing}">
                                  <div class="avatar-md bg-light rounded p-1 img-fluid-product position-relative">
                                    <img
                                      [src]="property?.image ? (pathImage + property.image) : 'assets/images/no-image-available1_1.jpeg'"
                                      alt="" class="img-fluid d-block" (error)="onImageError($event)" />
                                    <img *ngIf="property?.agent?.image" [src]="pathUserImage + property.agent?.image"
                                      class="img-agent avatar-xxs" (error)="onUserImageError($event)"
                                      [ngbTooltip]="property?.agent?.name" placement="top" [container]="'body'" />
                                  </div>
                                </div>

                                <div class="flex-grow-1 min-w-0">
                                  <div class="fs-13 mb-1" [ngClass]="{'placeholder-2':property?.isProcessing}">
                                    {{property.title}}
                                  </div>

                                  <p class="mb-0 small d-flex align-items-center gap-2"
                                    [ngClass]="{'placeholder-2':property?.isProcessing}">
                                    <span class="text-muted">{{ 't-m-properties.t-reference'| translate }}:</span>
                                    <span class="fs-12 text-truncate">{{property.reference}}</span>
                                    <ng-container *ngIf="property?.zone">
                                      <span class="text-muted">{{ 't-m-properties.t-zone' | translate }}:</span>
                                      <span class="fs-12 text-truncate" [ngbTooltip]="property.zone" placement="top"
                                        [container]="'body'">{{property.zone}}</span>
                                    </ng-container>

                                    <span *ngIf="property?.portalLogs && !portalExportError?.isExported"
                                      class="badge badge-soft-danger fw-medium ms-1"
                                      [ngbTooltip]="'t-property-has-portals-error' | translate" placement="top"
                                      [container]="'body'">
                                      <i class="mdi mdi-alert fs-16"></i>
                                    </span>
                                  </p>

                                  <div class="mt-1">
                                    <ng-container *ngIf="!property?.isProcessing">
                                      <span
                                        *ngIf="property?.businessStatus !== prospectingId || property?.status == true"
                                        class="badge text-uppercase" [ngClass]="{
                                      'badge-soft-success': property?.status && !property?.highlight,
                                      'badge-soft-danger': !property?.status,
                                      'badge-soft-info': property?.status && property?.highlight}">
                                        <ng-container *ngIf="property?.status && !property?.highlight">
                                          {{ 't-m-properties.t-active'| translate }}
                                        </ng-container>

                                        <ng-container *ngIf="property?.status && property?.highlight">
                                          {{ 't-highlight'| translate }}
                                        </ng-container>

                                        <ng-container *ngIf="!property?.status">
                                          {{ 't-m-properties.t-inactive'| translate }}
                                        </ng-container>
                                      </span>

                                      <span *ngIf="property?.exclusive" class="badge badge-soft-primary text-uppercase ms-1">
                                        {{ 't-exclusive' | translate }}
                                      </span>
                                    </ng-container>

                                    <ng-container *ngIf="property?.isProcessing">
                                      <span class="badge text-uppercase badge-outline-info"
                                        [ngbTooltip]="'t-processing-status-is-means-that-the-property-is-being-created-with-more-than-20-images' | translate"
                                        placement="top" [container]="'body'">
                                        {{ 't-processing'| translate }}...
                                      </span>
                                    </ng-container>
                                  </div>
                                </div>
                              </div>
                            </td>

                            <!-- Tipo de imóvel -->
                            <td class="text-wrap">
                              <div [ngClass]="{'placeholder-2':property?.isProcessing}">
                                <p class="mb-0">
                                  {{property.propertyType?.name}}
                                  {{property.propertyType2?.name?':':''}}
                                  <span class="fs-12" *ngIf="property.propertyType2?.name">
                                    {{property.propertyType2?.name}}
                                  </span>
                                </p>

                                <p class="text-muted mb-0 small" *ngIf="property.associatedProperty">
                                  <ng-container *ngIf="property?.propertyType?.type===2">
                                    {{ 't-m-properties.t-associated-development'| translate }}:
                                  </ng-container>
                                  <ng-container *ngIf="property?.propertyType?.type!==2">
                                    {{ 't-m-properties.t-associated-property'| translate }}:
                                  </ng-container>
                                  <span class="fs-12 btn-link cursor-pointer"
                                    (click)="openModalDevelopments(property.associatedProperty)">
                                    {{property.associatedProperty.reference}}
                                  </span>
                                </p>
                              </div>
                            </td>

                            <!-- Business type -->
                            <td class="w-xs text-nowrap">
                              <span [ngClass]="{'placeholder-2':property?.isProcessing}">
                                {{property.businessType?.name}}
                              </span>
                            </td>

                            <!-- Price -->
                            <td class="w-xs text-nowrap">
                              <span [ngClass]="{'placeholder-2':property?.isProcessing}">
                                {{priceFormat(property.price, property?.currency)}}
                              </span>
                            </td>

                            <!-- Store -->
                            <td class="text-nowrap">
                              <span [ngClass]="{'placeholder-2':property?.isProcessing}">
                                {{property.store?.name}}
                              </span>
                            </td>

                            <!-- Business status -->
                            <td class="text-nowrap">
                              <ng-container *ngIf="!property?.isProcessing && property?.businessStatus">
                                <span class="badge rounded-pill fs-12 text-uppercase" [ngClass]="{
                              'badge-soft-success': property.businessStatus?.code === 'AVAILABLE',
                              
                              'badge-soft-warning': property.businessStatus?.code === 'PROSPECTING'
                              || property.businessStatus?.code === 'CPCV'
                              || property.businessStatus?.code === 'DRAFT'
                              || property.businessStatus?.code === 'NO_ATTENTION',

                              'badge-soft-info': property.businessStatus?.code === 'RENTED'
                              || property.businessStatus?.code === 'RESERVED'
                              || property.businessStatus?.code === 'TO_VALIDATE'
                              || property.businessStatus?.code === 'DEED',

                              'badge-soft-danger' : property.businessStatus?.code === 'CANCELED'
                              || property.businessStatus?.code === 'REMOVED'
                              || property.businessStatus?.code === 'DECLINED'
                              || property.businessStatus?.code === 'SOLD' }">
                                  {{ property.businessStatus?.name }}
                                </span>
                              </ng-container>

                              <ng-container *ngIf="property?.isProcessing">
                                <span class="badge text-uppercase badge-outline-info"
                                  [ngbTooltip]="'t-processing-status-is-means-that-the-property-is-being-created-with-more-than-20-images' | translate"
                                  placement="top" [container]="'body'">
                                  {{ 't-processing' | translate }}...
                                </span>
                              </ng-container>
                            </td>

                            <!-- Updated at -->
                            <td class="align-middle text-nowrap">
                              <span [ngClass]="{'placeholder-2':property?.isProcessing}">
                                {{ createDateFormat(property.updated) }}
                              </span>
                            </td>

                            <td class="align-middle text-nowrap">
                              <span [ngClass]="{'placeholder-2':property?.isProcessing}">
                                {{ createDateFormat(property.createdAt) }}
                              </span>
                            </td>


                            <!-- Ações -->
                            <td class="text-end text-nowrap" style="width:120px;">
                              <div class="d-flex justify-content-end align-items-center gap-2">
                                <ng-container *ngIf="!property?.isProcessing">
                                  <a *ngIf="permissionsService.checkAgentPermission(property?.mainAgent, 'EDIT_PROPERTIES') || permissionsService.canEditProperty(loginUser, property?.store?.id)"
                                    class="btn btn-sm btn-link text-primary p-0" (click)="openModal(property)"
                                    [ngbTooltip]="'t-edit' | translate" placement="top" [container]="'body'"
                                    aria-label="Edit">
                                    <i class="ri-pencil-fill fs-16 align-bottom"></i>
                                  </a>

                                  <a *ngIf="!permissionsService.checkAgentPermission(property?.mainAgent, 'EDIT_PROPERTIES') && !permissionsService.canEditProperty(loginUser, property?.store?.id)"
                                    class="btn btn-sm btn-link text-primary p-0" (click)="openModal(property)"
                                    [ngbTooltip]="'t-view' | translate" placement="top" [container]="'body'"
                                    aria-label="View">
                                    <i class="ri-eye-line fs-16 align-bottom"></i>
                                  </a>

                                  <ng-container *appHasPermission="'CREATE_PROPERTIES'">
                                    <button
                                      *ngIf="permissionsService.checkAgentPermission(property?.mainAgent, 'EDIT_PROPERTIES') || permissionsService.canEditProperty(loginUser, property?.store?.id)"
                                      type="button" class="btn btn-sm btn-link text-secondary p-0"
                                      [disabled]="property?.isDuplicating" (click)="duplicateProperty(property)"
                                      [ngbTooltip]="'t-duplicate' | translate" placement="top" [container]="'body'"
                                      aria-label="Duplicate">
                                      <i class="fs-16 align-bottom"
                                        [ngClass]="property?.isDuplicating ? 'ri-loader-4-line spin' : 'ri-file-copy-line'"></i>
                                    </button>
                                  </ng-container>

                                  <ng-container *ngIf="!portalExportError?.status">
                                    <button type="button" class="btn btn-sm btn-link text-danger p-0"
                                      *ngIf="permissionsService.canDeleteProperty(loginUser, property?.store?.id)"
                                      (click)="confirm(property.id)" [ngbTooltip]="'t-delete' | translate"
                                      placement="top" [container]="'body'" aria-label="Delete">
                                      <i class="ri-delete-bin-fill fs-16 align-bottom"></i>
                                    </button>
                                  </ng-container>
                                </ng-container>

                                <!-- Estado processing: apenas ícones “fantasma” para manter largura -->
                                <ng-container *ngIf="property?.isProcessing">
                                  <span class="text-muted-50 p-0 placeholder-2 d-inline-block"><i
                                      class="ri-pencil-fill fs-16"></i></span>
                                  <span class="text-muted-50 p-0 placeholder-2 d-inline-block"><i
                                      class="ri-eye-line fs-16"></i></span>
                                  <span class="text-muted-50 p-0 placeholder-2 d-inline-block"><i
                                      class="ri-delete-bin-fill fs-16"></i></span>
                                </ng-container>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td [attr.colspan]="portalExportError?.status ? 9 : 10" class="p-0">
                              <div *ngIf="canOpenPropertySection(property, 'owner')" class="property-sections-bar px-3 py-2">
                                <button type="button" class="section-link"
                                  (click)="openPropertyDetailsModal(property, 'owner', propertyDetailsModal)">
                                  {{ 't-property-details-tab-owner' | translate }}
                                </button>

                                <button type="button" class="section-link" *ngIf="canOpenPropertySection(property, 'opportunities')"
                                  (click)="openPropertyDetailsModal(property, 'opportunities', propertyDetailsModal)">
                                  {{ 't-property-details-tab-opportunities' | translate }}
                                </button>

                                <!-- <button type="button" class="section-link"
                                  (click)="openPropertyDetailsModal(property, 'portals', propertyDetailsModal)">
                                  Site / Portais
                                </button> -->

                                <button type="button" class="section-link" *ngIf="canOpenPropertySection(property, 'visits')"
                                  (click)="openPropertyDetailsModal(property, 'visits', propertyDetailsModal)">
                                  {{ 't-property-details-tab-visits' | translate }}
                                </button>

                                <button type="button" class="section-link" *ngIf="canOpenPropertySection(property, 'keys')"
                                  (click)="openPropertyDetailsModal(property, 'keys', propertyDetailsModal)">
                                  {{ 't-property-details-tab-keys' | translate }}
                                </button>

                                <button type="button" class="section-link"
                                  (click)="openPropertyDetailsModal(property, 'plates', propertyDetailsModal)">
                                  {{ 't-property-details-tab-plates' | translate }}
                                </button>

                                <button type="button" class="section-link" *ngIf="canOpenPropertySection(property, 'history')"
                                  (click)="openPropertyDetailsModal(property, 'history', propertyDetailsModal)">
                                  {{ 't-property-history-tab' | translate }}
                                </button>

                                <!-- <button type="button" class="section-link"
                                  (click)="openPropertyDetailsModal(property, 'process', propertyDetailsModal)">
                                  Gestão processos
                                </button>

                                <button type="button" class="section-link"
                                  (click)="openPropertyDetailsModal(property, 'prices', propertyDetailsModal)">
                                  Histórico de Preços
                                </button> -->
                              </div>
                            </td>
                          </tr>
                          <!-- LINHA EXPANDIDA 100% -->
                        </ng-container>
                      </tbody>

                      <ng-template #propertyDetailsModal let-modal>
                        <div class="pdm">
                          <!-- Cabeçalho -->
                          <div class="pdm-header">
                            <div class="pdm-header-icon"><i class="ri-building-line"></i></div>
                            <div class="pdm-header-text">
                              <h5 class="pdm-title">{{ selectedProperty?.title }}</h5>
                              <span class="pdm-ref">{{ 't-property-details-ref' | translate }}: {{ selectedProperty?.reference }}</span>
                            </div>
                            <button type="button" class="pdm-close" [attr.aria-label]="'t-general.t-btn-close' | translate"
                              (click)="modal.dismiss()"><i class="ri-close-line"></i></button>
                          </div>

                          <!-- Separadores -->
                          <ul ngbNav #nav="ngbNav" [activeId]="selectedModalTab" class="pdm-tabs" role="tablist">
                            <li [ngbNavItem]="'owner'">
                              <button ngbNavLink type="button" class="pdm-tab" role="tab"
                                (click)="changeTabModal('owner')"
                                [class.active]="selectedModalTab === 'owner'"
                                [attr.aria-selected]="selectedModalTab === 'owner'">
                                {{ 't-property-details-tab-owner' | translate }}
                                <span class="pdm-count" *ngIf="detailsCount('owner') !== null">{{ detailsCount('owner') }}</span>
                              </button>
                            </li>
                            <li [ngbNavItem]="'opportunities'" *ngIf="canOpenPropertySection(selectedProperty, 'opportunities')">
                              <button ngbNavLink type="button" class="pdm-tab" role="tab"
                                (click)="changeTabModal('opportunities')"
                                [class.active]="selectedModalTab === 'opportunities'"
                                [attr.aria-selected]="selectedModalTab === 'opportunities'">
                                {{ 't-property-details-tab-opportunities' | translate }}
                                <span class="pdm-count" *ngIf="detailsCount('opportunities') !== null">{{ detailsCount('opportunities') }}</span>
                              </button>
                            </li>
                            <li [ngbNavItem]="'visits'" *ngIf="canOpenPropertySection(selectedProperty, 'visits')">
                              <button ngbNavLink type="button" class="pdm-tab" role="tab"
                                (click)="changeTabModal('visits')"
                                [class.active]="selectedModalTab === 'visits'"
                                [attr.aria-selected]="selectedModalTab === 'visits'">
                                {{ 't-property-details-tab-visits' | translate }}
                                <span class="pdm-count" *ngIf="detailsCount('visits') !== null">{{ detailsCount('visits') }}</span>
                              </button>
                            </li>
                            <li [ngbNavItem]="'keys'" *ngIf="canOpenPropertySection(selectedProperty, 'keys')">
                              <button ngbNavLink type="button" class="pdm-tab" role="tab"
                                (click)="changeTabModal('keys')"
                                [class.active]="selectedModalTab === 'keys'"
                                [attr.aria-selected]="selectedModalTab === 'keys'">
                                {{ 't-property-details-tab-keys' | translate }}
                                <span class="pdm-count">{{ detailsCount('keys') }}</span>
                              </button>
                            </li>
                            <li [ngbNavItem]="'plates'">
                              <button ngbNavLink type="button" class="pdm-tab" role="tab"
                                (click)="changeTabModal('plates')"
                                [class.active]="selectedModalTab === 'plates'"
                                [attr.aria-selected]="selectedModalTab === 'plates'">
                                {{ 't-property-details-tab-plates' | translate }}
                                <span class="pdm-count">{{ detailsCount('plates') }}</span>
                              </button>
                            </li>
                            <li [ngbNavItem]="'history'" *ngIf="canOpenPropertySection(selectedProperty, 'history')">
                              <button ngbNavLink type="button" class="pdm-tab" role="tab"
                                (click)="changeTabModal('history')"
                                [class.active]="selectedModalTab === 'history'"
                                [attr.aria-selected]="selectedModalTab === 'history'">
                                {{ 't-property-history-tab' | translate }}
                              </button>
                              <!-- Carregado só ao abrir o separador (ngbNavContent é preguiçoso). -->
                              <ng-template ngbNavContent>
                                <div class="pdm-history">
                                  <app-property-history [propertyId]="selectedProperty?.id"></app-property-history>
                                </div>
                              </ng-template>
                            </li>
                          </ul>

                          <!-- Tabelas: Proprietário, Oportunidades, Visitas -->
                          <ng-container *ngIf="selectedModalTab === 'owner' || selectedModalTab === 'opportunities' || selectedModalTab === 'visits'">
                            <div class="pdm-toolbar">
                              <div class="pdm-search">
                                <i class="ri-search-line"></i>
                                <input type="text" class="form-control" [ngModel]="detailsSearch"
                                  (ngModelChange)="onDetailsSearch($event)"
                                  [placeholder]="'t-property-details-search-' + selectedModalTab | translate" />
                              </div>
                            </div>

                            <div class="pdm-body">
                              <div class="pdm-state" *ngIf="detailsLoading && !detailsPaged.length">
                                <span class="spinner-border spinner-border-sm text-primary me-2"></span>
                                {{ 't-property-details-loading' | translate }}
                              </div>

                              <div class="pdm-state" *ngIf="!detailsLoading && !detailsPaged.length">
                                <i class="ri-inbox-line"></i>
                                {{ (detailsSearch ? 't-property-details-no-match' : 't-no-result-message') | translate }}
                              </div>

                              <div class="table-responsive" *ngIf="detailsPaged.length">
                                <table class="pdm-table">
                                  <thead>
                                    <tr>
                                      <th>{{ (selectedModalTab === 'owner' ? 't-property-details-col-owner' : 't-property-details-col-client') | translate }}</th>
                                      <th *ngIf="selectedModalTab === 'owner'">{{ 't-phone' | translate }}</th>
                                      <th *ngIf="selectedModalTab !== 'owner'">{{ 't-property-details-col-agent' | translate }}</th>
                                      <th>{{ (selectedModalTab === 'visits' ? 't-property-details-col-visit' : 't-property-details-col-status') | translate }}</th>
                                      <th *ngIf="selectedModalTab !== 'owner'">
                                        {{ (selectedModalTab === 'visits' ? 't-property-details-col-date' : 't-property-details-col-updated') | translate }}
                                      </th>
                                      <th class="text-end">{{ 't-property-details-col-actions' | translate }}</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr *ngFor="let row of detailsPaged; trackBy: trackDetailsRow" (click)="openDetailsRow(row, $event)">
                                      <td>
                                        <div class="pdm-person">
                                          <span class="pdm-avatar">{{ row.initials }}</span>
                                          <div class="min-w-0">
                                            <div class="pdm-name text-truncate">{{ row.name }}</div>
                                            <div class="pdm-sub text-truncate" *ngIf="row.subtitle">{{ row.subtitle }}</div>
                                          </div>
                                        </div>
                                      </td>
                                      <td *ngIf="selectedModalTab === 'owner'" class="pdm-muted">{{ row.extra || '-' }}</td>
                                      <td *ngIf="selectedModalTab !== 'owner'">
                                        <div class="pdm-agent" *ngIf="row.agentName; else noAgent">
                                          <span class="pdm-avatar pdm-avatar-sm">{{ row.agentInitials }}</span>
                                          <span class="text-truncate">{{ row.agentName }}</span>
                                        </div>
                                        <ng-template #noAgent><span class="pdm-muted">-</span></ng-template>
                                      </td>
                                      <td>
                                        <span class="pdm-pill" [ngClass]="'tone-' + row.statusTone">
                                          <i [class]="row.statusIcon"></i>
                                          {{ row.statusKey ? (row.statusKey | translate) : row.statusText }}
                                        </span>
                                      </td>
                                      <td *ngIf="selectedModalTab !== 'owner'" class="pdm-date"
                                        [ngbTooltip]="row.dateTitle ? (row.dateTitle | date: 'dd/MM/yyyy HH:mm') : ''" container="body">
                                        {{ row.dateLabel || '-' }}
                                      </td>
                                      <td class="text-end">
                                        <button type="button" class="pdm-action" (click)="openDetailsRow(row, $event)"
                                          [ngbTooltip]="(row.kind === 'owner' ? 't-property-details-open-contact' : 't-property-details-open-deal') | translate"
                                          container="body">
                                          <i [class]="row.kind === 'owner' ? 'ri-user-settings-line' : 'ri-external-link-line'"></i>
                                        </button>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>

                            <div class="pdm-footer" *ngIf="detailsFiltered.length">
                              <span class="pdm-muted">
                                {{ 't-property-details-showing-' + selectedModalTab | translate: { count: detailsPaged.length, total: detailsFiltered.length } }}
                              </span>
                              <ngb-pagination [collectionSize]="detailsFiltered.length" [pageSize]="detailsPageSize"
                                [page]="detailsPage" (pageChange)="onDetailsPageChange($event)" [maxSize]="4" [rotate]="true"
                                size="sm">
                                <ng-template ngbPaginationPrevious>{{ 't-property-history-previous' | translate }}</ng-template>
                                <ng-template ngbPaginationNext>{{ 't-property-history-next' | translate }}</ng-template>
                              </ngb-pagination>
                            </div>
                          </ng-container>

                          <!-- Chaves -->
                          <div class="pdm-body pdm-cards" *ngIf="selectedModalTab === 'keys'">
                            <ng-container *ngIf="detailsKeys.address || detailsKeys.number; else noKeys">
                              <div class="pdm-card">
                                <div class="pdm-card-icon"><i class="ri-map-pin-line"></i></div>
                                <div>
                                  <div class="pdm-card-label">{{ 't-property-details-key-location' | translate }}</div>
                                  <div class="pdm-card-value">{{ detailsKeys.address || ('t-property-details-no-record' | translate) }}</div>
                                </div>
                              </div>
                              <div class="pdm-card">
                                <div class="pdm-card-icon"><i class="ri-key-2-line"></i></div>
                                <div>
                                  <div class="pdm-card-label">{{ 't-property-details-key-number' | translate }}</div>
                                  <div class="pdm-card-value">{{ detailsKeys.number || ('t-property-details-no-record' | translate) }}</div>
                                </div>
                              </div>
                            </ng-container>
                            <ng-template #noKeys>
                              <div class="pdm-state w-100"><i class="ri-key-line"></i>{{ 't-property-details-no-keys' | translate }}</div>
                            </ng-template>
                          </div>

                          <!-- Placas -->
                          <div class="pdm-body pdm-cards" *ngIf="selectedModalTab === 'plates'">
                            <ng-container *ngIf="detailsPlate.has; else noPlate">
                              <div class="pdm-card">
                                <div class="pdm-card-icon"><i class="ri-signpost-line"></i></div>
                                <div>
                                  <div class="pdm-card-label">{{ 't-property-details-plate' | translate }}</div>
                                  <div class="pdm-card-value">
                                    <span class="pdm-pill tone-success"><i class="ri-checkbox-circle-line"></i>{{ 't-yes' | translate }}</span>
                                  </div>
                                </div>
                              </div>
                              <div class="pdm-card">
                                <div class="pdm-card-icon"><i class="ri-calendar-check-line"></i></div>
                                <div>
                                  <div class="pdm-card-label">{{ 't-property-details-plate-placed' | translate }}</div>
                                  <div class="pdm-card-value">
                                    {{ detailsPlate.placedAt ? (detailsPlate.placedAt | date: 'dd/MM/yyyy') : ('t-property-details-no-record' | translate) }}
                                  </div>
                                </div>
                              </div>
                              <div class="pdm-card">
                                <div class="pdm-card-icon"><i class="ri-calendar-close-line"></i></div>
                                <div>
                                  <div class="pdm-card-label">{{ 't-property-details-plate-removed' | translate }}</div>
                                  <div class="pdm-card-value">
                                    {{ detailsPlate.removedAt ? (detailsPlate.removedAt | date: 'dd/MM/yyyy') : ('t-property-details-no-record' | translate) }}
                                  </div>
                                </div>
                              </div>
                            </ng-container>
                            <ng-template #noPlate>
                              <div class="pdm-state w-100"><i class="ri-signpost-line"></i>{{ 't-property-details-no-plate' | translate }}</div>
                            </ng-template>
                          </div>

                          <!-- Histórico (conteúdo do ngbNav) -->
                          <div [ngbNavOutlet]="nav"></div>
                        </div>
                      </ng-template>

                      <!-- LISTAGEM HIGHLIGHT (drag & drop) -->
                      <tbody *ngIf="propertyFilters.highlight && loginUser.role?.name === 'MASTER'" cdkDropList
                        (cdkDropListDropped)="drop($event)">
                        <tr class="cursor-move" *ngFor="let property of properties" cdkDrag>
                          <td class="text-center" style="width:48px;">
                            <div class="form-check m-0 d-flex justify-content-center">
                              <input class="form-check-input" type="checkbox" name="checkAll"
                                [(ngModel)]="property.isSelected" (change)="checkUncheckAll(false)" />
                            </div>
                          </td>

                          <td (click)="openPreviewModal(modalPreview, property)" class="cursor-pointer">
                            <div class="d-flex align-items-center">
                              <div class="flex-shrink-0 me-3">
                                <div class="avatar-md bg-light rounded p-1 img-fluid-product position-relative">
                                  <img [src]="pathImage + property.image" alt="" class="img-fluid d-block" />
                                  <img *ngIf="property?.agent?.image" [src]="pathUserImage + property.agent?.image"
                                    class="img-agent avatar-xxs" (error)="onUserImageError($event)"
                                    [ngbTooltip]="property?.agent?.name" placement="top" [container]="'body'" />
                                </div>
                              </div>
                              <div class="flex-grow-1 min-w-0">
                                <div class="fs-13 mb-1">
                                  {{property.title}}
                                </div>
                                <p class="mb-0 small">
                                  <span class="text-muted">{{ 't-m-properties.t-reference'| translate }}:</span>
                                  <span class="fs-12">{{property.reference}}</span>
                                </p>
                                <p *ngIf="property?.zone" class="mb-0 small">
                                  <span class="text-muted">{{ 't-m-properties.t-zone' | translate }}:</span>
                                  <span class="fs-12">{{property.zone}}</span>
                                </p>
                              </div>
                            </div>
                          </td>

                          <td class="text-wrap">
                            <p class="mb-0">
                              {{property.propertyType?.name}}
                              {{property.propertyType2?.name?':':''}}
                              <span class="fs-12" *ngIf="property.propertyType2?.name">
                                {{property.propertyType2?.name}}
                              </span>
                            </p>
                            <p class="text-muted mb-0 small" *ngIf="property.associatedProperty">
                              <ng-container *ngIf="property?.propertyType?.type===2">
                                {{ 't-m-properties.t-associated-development'| translate }}:
                              </ng-container>
                              <ng-container *ngIf="property?.propertyType?.type!==2">
                                {{ 't-m-properties.t-associated-property'| translate }}:
                              </ng-container>
                              <span class="fs-12 btn-link cursor-pointer"
                                (click)="openModal(property.associatedProperty)">
                                {{property.associatedProperty.reference}}
                              </span>
                            </p>
                          </td>

                          <td class="w-xs text-nowrap">{{property.businessType?.name}}</td>
                          <td class="w-xs text-nowrap">{{priceFormat(property.price) || 0}}</td>
                          <td class="text-nowrap">{{property.store?.name}}</td>
                          <td class="text-nowrap">
                            <span class="badge text-uppercase badge-soft-infoss">
                              <ng-container *ngIf="property?.status">
                                {{ 't-highlight'| translate }}
                              </ng-container>
                            </span>
                          </td>
                          <td class="text-nowrap">{{createDateFormat(property.updated)}}</td>
                          <td class="text-nowrap">{{createDateFormat(property.createdAt)}}</td>

                          <td class="text-end text-nowrap" style="width:120px;">
                            <div class="d-flex justify-content-end align-items-center gap-2">
                              <a *ngIf="permissionsService.checkAgentPermission(property?.mainAgent, 'EDIT_PROPERTIES') || permissionsService.canEditProperty(loginUser, property?.store?.id)"
                                class="btn btn-sm btn-link text-primary p-0" (click)="openModal(property)"
                                [ngbTooltip]="'t-edit' | translate" placement="top" [container]="'body'"
                                aria-label="Edit">
                                <i class="ri-pencil-fill fs-16 align-bottom"></i>
                              </a>

                              <a *ngIf="!permissionsService.checkAgentPermission(property?.mainAgent, 'EDIT_PROPERTIES') && !permissionsService.canEditProperty(loginUser, property?.store?.id)"
                                class="btn btn-sm btn-link text-primary p-0" (click)="openModal(property)"
                                [ngbTooltip]="'t-view' | translate" placement="top" [container]="'body'"
                                aria-label="View">
                                <i class="ri-eye-line fs-16 align-bottom"></i>
                              </a>

                              <ng-container *appHasPermission="'CREATE_PROPERTIES'">
                                <button
                                  *ngIf="permissionsService.checkAgentPermission(property?.mainAgent, 'EDIT_PROPERTIES') || permissionsService.canEditProperty(loginUser, property?.store?.id)"
                                  type="button" class="btn btn-sm btn-link text-secondary p-0"
                                  [disabled]="property?.isDuplicating" (click)="duplicateProperty(property)"
                                  [ngbTooltip]="'t-duplicate' | translate" placement="top" [container]="'body'"
                                  aria-label="Duplicate">
                                  <i class="fs-16 align-bottom"
                                    [ngClass]="property?.isDuplicating ? 'ri-loader-4-line spin' : 'ri-file-copy-line'"></i>
                                </button>
                              </ng-container>

                              <button type="button" class="btn btn-sm btn-link text-danger p-0"
                                *ngIf="permissionsService.canDeleteProperty(loginUser, property?.store?.id)"
                                (click)="confirm(property.id)" [ngbTooltip]="'t-delete' | translate" placement="top"
                                [container]="'body'" aria-label="Delete">
                                <i class="ri-delete-bin-fill fs-16 align-bottom"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- FOOTER / PAGINAÇÃO (normal) -->
                  <div class="row justify-content-md-between align-items-md-center mt-3"
                    *ngIf="total>0 && !propertyFilters.highlight">
                    <div class="col-12 col-sm-6">
                      <div class="dataTables_info mb-2" id="tickets-table_info" role="status" aria-live="polite">
                        {{'t-showing' | translate}} {{startIndex}} {{'t-table-to' | translate}} {{endIndex}}
                        {{'t-table-of' | translate}} {{total}} {{'t-table-entries' | translate}}
                      </div>
                    </div>

                    <div class="col-12 col-sm-6">
                      <div class="text-sm-right me-2 float-sm-end listjs-pagination">
                        <ngb-pagination [collectionSize]="(total)" [maxSize]="6" [(page)]="page" [pageSize]="pageSize"
                          (pageChange)="refreshProperties()">
                        </ngb-pagination>
                      </div>
                    </div>
                  </div>

                  <!-- FOOTER / HIGHLIGHT -->
                  <div class="row justify-content-md-between align-items-md-center mt-3"
                    *ngIf="total>0 && propertyFilters.highlight">
                    <div class="col-12 col-sm-6">
                      <div class="dataTables_info mb-2" id="tickets-table_info" role="status" aria-live="polite">
                        {{'t-showing' | translate}} {{startIndex}} {{'t-table-to' | translate}} {{total}}
                        {{'t-table-of' | translate}} {{total}} {{'t-table-entries' | translate}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="py-4 text-center" *ngIf="noresult">
                <div>
                  <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop"
                    colors="primary:#405189,secondary:#0ab39c" style="width:72px;height:72px">
                  </lord-icon>
                </div>
                <div class="mt-4">
                  <h5>{{'t-no-result-message' | translate}}</h5>
                </div>
              </div>
            </ng-template>
          </li>

          <li [ngbNavItem]="2" class="nav-item">
            <a ngbNavLink class="nav-link">
              {{'t-developments.t-title' | translate}}
            </a>
            <ng-template ngbNavContent>
              <app-list-developments [propertyToUpdate]="propertyToUpdate"
                (propertyUpdateChange)="onChildValueChange($event)" [allData]="allData"></app-list-developments>
            </ng-template>
          </li>
        </ul>
      </div>
      <div [ngbNavOutlet]="customNav"></div>
    </div>
  </div>
</div>

<app-create-edit [openProposal]="openProposal" [property]="property" [canActivateProperties]="canActivateProperties"
  *ngIf="isOpenModal" [dataToFormInitDetails]="dataToFormInitDetails" [dataToFormInitAddress]="dataToFormInitAddress"
  [dataToFormInitAreasNearby]="dataToFormInitAreasNearby" [dataToFormInitChar]="dataToFormInitChar"
  [dataToFormInitAdvertisement]="dataToFormInitAdvertisement" [dataToFormInitAgents]="dataToFormInitAgents"
  [dataToFormInitPortals]="dataToFormInitPortals" [openModaltSubject$]="openModaltSubject$"
  [prospectingId]="prospectingId" [requiredOwner]="requiredOwner"
  [openTab]="autoOpenEditFromPreview ? autoOpenEditTab : null"></app-create-edit>

<div class="propertyLoaderPageList" *ngIf="isLoadingList">
  <div class="avatar-sm spinner-border text-primary" role="status">
    <span class="visually-hidden">wait...</span>
  </div>
</div>

<div *ngIf="nabTabActive === 1" class="offcanvas offcanvas-end h-100" tabindex="-1" id="offcanvasExample"
  aria-labelledby="offcanvasExampleLabel" style="visibility: hidden;" aria-hidden="true" #property_filters_offcanvas
  data-bs-backdrop="false">
  <div class="offcanvas-header bg-light">
    <h5 class="offcanvas-title" id="offcanvasExampleLabel">
      {{ 't-property-quick-filters.t-advanced' | translate }}
    </h5>

    <span class="badge border border-dark ms-1 text-body fs-12">
      {{countFilters$.getValue()}}
    </span>

    <button type="button" class="btn-close text-reset d-none" (click)="closeFilters()">
    </button>

    <button type="button" class="d-none" id="closeCBtn" data-bs-dismiss="offcanvas" aria-label="Close"
      #button_close_property_filters>
    </button>
  </div>
  <!--end offcanvas-header-->

  <div class="offcanvas-body p-1">
    <!-- <ngx-simplebar class="px-3 mx-n3 mb-2" style="height: calc(100vh - calc(70px + 1.5rem + 60px + 125px));"
            [options]="{ forceVisible: true }"> -->
    <form [formGroup]="propertiesFiltersForm" *ngIf="properties &&  openModaltSubject$.getValue()>=5">
      <div class="card">

        <div class="accordion accordion-flush filter-accordion">
          <!-- Novo filtro de âmbito da pesquisa -->
          <div class="card-body pb-0 border-bottom" *ngIf="!permissionsService.isRealMaster(loginUser.role?.name)">
            <div class="mb-3">
              <label class="form-label text-uppercase fw-medium fs-12">{{'t-search-scope' | translate}}</label>
              <ng-select [clearable]="false" [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedScope"
                (change)="onScopeChange($event)">
                <ng-option *ngFor="let scope of scopeOptions" [value]="scope.value">
                  {{scope.label | translate}}
                </ng-option>
              </ng-select>
            </div>
          </div>
          <div class="card-body border-bottom">
            <div *ngIf="!filtersForm['showNetworkProperties']?.value" class="mb-3">
              <label for="propertyStoreInput" class="form-label text-uppercase fs-12 fw-medium ">
                {{ 't-m-properties.t-store' | translate }}
              </label>
              <ng-select [items]="stores" [multiple]="true" bindLabel="name" bindValue="id" [clearable]="false"
                groupBy="groupDescription" class="seleect-group-item" placeholder="---" formControlName="stores"
                [readonly]="lockedStores.length > 0"
                [title]="lockedStores.length ? ('t-agency-context-locked' | translate) : ''">
              </ng-select>
            </div>
            <div class="align-items-center d-flex gap-1 mb-3"
              *ngIf="permissionsService.isMaster(loginUser.role?.name) && !filtersForm['showNetworkProperties']?.value">
              <div class="w-100">
                <label for="propertyAgentInput" class="form-label text-uppercase fs-12 fw-medium ">
                  {{ 't-m-properties.t-agents' | translate }}
                </label>
                <ng-select [items]="agents" [multiple]="true" bindLabel="name" bindValue="id" [clearable]="false"
                  groupBy="groupDescription" class="seleect-group-item" placeholder="---" formControlName="agents">
                </ng-select>
              </div>
              <div class="dropdown mt-4">
                <button class="btn btn-icon btn-sm fs-16 text-muted dropdown" type="button" data-bs-toggle="dropdown"
                  aria-expanded="false" data-bs-auto-close="outside">
                  <i class="ri-more-fill"></i>
                </button>
                <ul class="dropdown-menu p-3" style="min-width: 12rem;">
                  <li class="py-2">
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" role="switch" id="t-listing-agent"
                        formControlName="listingAgent">
                      <label class="form-check-label" for="t-listing-agent">
                        {{ 't-properties-agents.t-listing-agent' | translate }}
                      </label>
                    </div>
                  </li>
                  <li class="py-2">
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" role="switch" id="t-secondary-agent"
                        formControlName="secondaryAgent">
                      <label class="form-check-label" for="t-secondary-agent">
                        {{ 't-properties-agents.t-secondary-agent' | translate }}
                      </label>
                    </div>
                  </li>

                </ul>
              </div>
            </div>
            <div class="mb-3">
              <label for="propertytypeInput" class="form-label text-uppercase fs-12 fw-medium ">
                {{ 't-m-properties.t-property-type' | translate }}
              </label>
              <ng-select [items]="propertyTypes" [multiple]="true" bindLabel="description" bindValue="id"
                [clearable]="true" groupBy="groupDescription" [selectableGroup]="true"
                [selectableGroupAsModel]="false" [closeOnSelect]="false"
                class="seleect-group-item" placeholder="---" formControlName="propertyTypes">
                <ng-template ng-optgroup-tmp let-item="item" let-item$="item$">
                  <span class="property-type-group-option" [class.is-selected]="item$?.selected">
                    <i class="fs-14"
                      [ngClass]="item$?.selected ? 'ri-checkbox-circle-fill text-primary' : 'ri-checkbox-blank-circle-line text-muted'"></i>
                    <span class="text-truncate">
                      {{item.groupDescription==='---'?'N/A':item.groupDescription || 'Unnamed group'}}
                    </span>
                  </span>
                </ng-template>
              </ng-select>
            </div>
            <div class="mb-3">
              <label class="form-label text-uppercase fs-12 fw-medium ">{{'t-typology' | translate}}</label>
              <ng-select [items]="typologies" [multiple]="true" bindLabel="name" bindValue="id" [clearable]="true"
                class="seleect-group-item" placeholder="---" formControlName="typology"></ng-select>
            </div>
          </div>
          <div class="card-body border-bottom">
            <div class="mb-3">
              <label class="form-label text-uppercase fs-12 fw-medium ">{{ 't-m-properties.t-district' | translate
                }}</label>
              <ng-select [items]="districts" [multiple]="true" bindLabel="name" bindValue="id" [clearable]="false"
                class="seleect-group-item" placeholder="---" formControlName="district"></ng-select>
            </div>
            <div class="mb-3">
              <label class="form-label text-uppercase fs-12 fw-medium ">{{ 't-m-properties.t-county' | translate
                }}</label>
              <ng-select [items]="counties" [multiple]="true" bindLabel="name" bindValue="id" [clearable]="false"
                class="seleect-group-item" placeholder="---" formControlName="county"></ng-select>
            </div>
            <div class="mb-3">
              <label class="form-label text-uppercase fs-12 fw-medium ">{{ 't-m-properties.t-parish' | translate
                }}</label>
              <ng-select [items]="parish" [multiple]="true" bindLabel="name" bindValue="id" [clearable]="false"
                class="seleect-group-item" placeholder="---" formControlName="parish"></ng-select>
            </div>
          </div>
          <!-- <div class="card-body border-bottom">
            <p class=" fs-12 fw-medium">
              <span class="text-uppercase">
                {{ 't-m-properties.t-useful-area' | translate }}
              </span>

              (m<sup>2</sup>)

            </p>

            <div class="formCost d-flex gap-2 align-items-center mt-3">
              <input class="form-control form-control-sm" type="number" id="minUsefulArea" placeholder="Min"
                formControlName="minUsefulArea" (blur)="touch($event)">
              <span class="fw-semibold text-muted">
                {{ 't-range-to' | translate }}
              </span>
              <input class="form-control form-control-sm" type="number" id="maxUsefulArea" placeholder="Max"
                formControlName="maxUsefulArea" (blur)="touch($event)">
            </div>
          </div> -->

          <div class="card-body border-bottom">
            <p class="text-uppercase fs-12 fw-medium">{{ 't-m-properties.t-price' | translate }}</p>
            <ngx-slider [value]="propertiesFiltersForm.get('minPrice')?.value"
              [highValue]="propertiesFiltersForm.get('maxPrice')?.value" [options]="options"
              (valueChange)="changePrice($event)" (highValueChange)="changePrice($event,false)"></ngx-slider>

            <div class="formCost d-flex gap-2 align-items-center mt-3">
              <input class="form-control form-control-sm" type="number" id="minPrice" formControlName="minPrice">
              <span class="fw-semibold text-muted">
                {{ 't-range-to' | translate }}
              </span> <input class="form-control form-control-sm" type="number" id="maxPrice"
                formControlName="maxPrice">
            </div>
          </div>

          <div class="card-body border-bottom">
            <p class="text-uppercase fs-12 fw-medium">{{ 't-exclusives-only' | translate }}</p>
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" role="switch" id="exclusivesOnly"
                formControlName="exclusive">
            </div>
          </div>

          <div class="card-body border-bottom">
            <p class="text-uppercase fs-12 fw-medium">{{ 't-website-visibility' | translate }}</p>
            <div class="d-flex flex-column gap-2">
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" role="switch" id="websiteStatus"
                  formControlName="websiteStatus">
                <label class="form-check-label" for="websiteStatus">
                  {{ 't-published-website' | translate }}
                </label>
              </div>
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" role="switch" id="websiteHighlight"
                  formControlName="websiteHighlight">
                <label class="form-check-label" for="websiteHighlight">
                  {{ 't-highlighted-website' | translate }}
                </label>
              </div>
            </div>
          </div>

          <div class="accordion-item">
            <h2 class="accordion-header" id="filter-conditions">
              <button class="accordion-button bg-transparent shadow-none collapsed" type="button"
                data-bs-toggle="collapse" data-bs-target="#filter-collapseConditions" aria-expanded="true"
                aria-controls="filter-collapseConditions">
                <span class="text-uppercase fs-12 fw-medium">
                  {{ 't-m-properties.t-condition' |translate }}
                </span> <span
                  class="align-middle badge border border-dark filter-badge ms-1 text-body">{{countFiltersconditions}}</span>
              </button>
            </h2>

            <div id="filter-collapseConditions" class="accordion-collapse collapse "
              aria-labelledby="filter-conditions">
              <div class="accordion-body text-body pt-0">

                <div class="d-flex flex-column gap-2 mt-3 filter-check">

                  <div class="form-check" *ngFor="let condition of conditions">
                    <input class="form-check-input" type="checkbox" id="filterCondition{{condition.id}}"
                      formControlName="condition_{{condition.id}}">
                    <label class="form-check-label"
                      for="filterCondition{{condition.id}}">{{condition.description}}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end accordion-item -->

          <div class="accordion-item">
            <h2 class="accordion-header" id="filter-businessStatus">
              <button class="accordion-button bg-transparent shadow-none collapsed" type="button"
                data-bs-toggle="collapse" data-bs-target="#filter-collapseBusinessStatus" aria-expanded="true"
                aria-controls="filter-collapseBusinessStatus">
                <span class="text-uppercase fs-12 fw-medium">
                  {{ 't-m-properties.t-business-status' |translate }}
                </span> <span
                  class="align-middle badge border border-dark filter-badge ms-1 text-body">{{countFiltersBusinessStatus}}</span>
              </button>
            </h2>

            <div id="filter-collapseBusinessStatus" class="accordion-collapse collapse"
              aria-labelledby="filter-businessStatus">
              <div class="accordion-body text-body pt-1">
                <div class="d-flex flex-column gap-2 filter-check">
                  <div class="form-check" *ngFor="let bStatus of filtersBusinessStatus">
                    <input class="form-check-input" type="checkbox" value="{{bStatus.id}}"
                      id="filterbusinessStatus{{bStatus.id}}" formControlName="businessStatus_{{bStatus.id}}">

                    <label class="form-check-label" for="filterbusinessStatus{{bStatus.id}}">
                      {{bStatus.description}}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end accordion-item -->

          <div class="accordion-item">
            <h2 class="accordion-header" id="filter-businessTypes">
              <button class="accordion-button bg-transparent shadow-none collapsed" type="button"
                data-bs-toggle="collapse" data-bs-target="#filter-collapseBusinessTypes" aria-expanded="true"
                aria-controls="filter-collapseBusinessTypes">

                <span class="text-uppercase fs-12 fw-medium">
                  {{ 't-m-properties.t-business-type' |translate }}
                </span> <span
                  class="align-middle badge border border-dark filter-badge ms-1 text-body">{{countFiltersBusinessTypes}}</span>
              </button>
            </h2>

            <div id="filter-collapseBusinessTypes" class="accordion-collapse collapse"
              aria-labelledby="filter-businessTypes">
              <div class="accordion-body text-body pt-1">
                <div class="d-flex flex-column gap-2 filter-check">
                  <div class="form-check" *ngFor="let bTypes of businessTypes">
                    <input class="form-check-input" type="checkbox" value="{{bTypes.id}}"
                      id="filterBusinessTypes{{bTypes.id}}" formControlName="businessTypes_{{bTypes.id}}" />

                    <label class="form-check-label" for="filterBusinessTypes{{bTypes.id}}">
                      {{bTypes.description}}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- end accordion-item -->

          <!-- end accordion-item -->
          <div class="accordion-item">
            <h2 class="accordion-header" id="filter-EC">
              <button class="accordion-button bg-transparent shadow-none collapsed" type="button"
                data-bs-toggle="collapse" data-bs-target="#filter-collapseEC" aria-expanded="true"
                aria-controls="filter-collapseEC">
                <span class="text-uppercase fs-12 fw-medium">
                  {{ 't-m-properties.t-energetic-certification' | translate }}
                </span> <span
                  class="align-middle badge border border-dark filter-badge ms-1 text-body">{{countFiltersECS}}</span>
              </button>
            </h2>
            <div id="filter-collapseEC" class="accordion-collapse collapse" aria-labelledby="filter-EC">
              <div class="accordion-body text-body pt-1">
                <div class="d-flex flex-column gap-2 filter-check">
                  <div class="form-check" *ngFor="let e of ecs">
                    <input class="form-check-input" type="checkbox" value="{{e.id}}" id="filterEC{{e.id}}"
                      formControlName="ec_{{e.id}}">
                    <label class="form-check-label" for="filterEC{{e.id}}">
                      {{e.description}}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- end accordion-item -->

          <div class="accordion-item">
            <h2 class="accordion-header" id="filter-area">
              <button class="accordion-button bg-transparent shadow-none collapsed" type="button"
                data-bs-toggle="collapse" data-bs-target="#filter-collapseArea" aria-expanded="true"
                aria-controls="filter-collapseArea">
                <span class="text-uppercase fs-12 fw-medium">
                  <span class="text-uppercase">
                    {{ 't-m-properties.t-useful-area' | translate }}
                  </span>

                  (m<sup>2</sup>)
                </span>
              </button>
            </h2>

            <div id="filter-collapseArea" class="accordion-collapse collapse " aria-labelledby="filter-year">
              <div class="accordion-body text-body pt-0">

                <div class="formCost d-flex gap-2 align-items-center mt-3">
                  <input class="form-control form-control-sm" type="number" id="minUsefulArea" placeholder="Min"
                    formControlName="minUsefulArea" (blur)="touch($event)">
                  <span class="fw-semibold text-muted">
                    {{ 't-range-to' | translate }}
                  </span>
                  <input class="form-control form-control-sm" type="number" id="maxUsefulArea" placeholder="Max"
                    formControlName="maxUsefulArea" (blur)="touch($event)">
                </div>
              </div>
            </div>
          </div>

          <div class="accordion-item">
            <h2 class="accordion-header" id="filter-year">
              <button class="accordion-button bg-transparent shadow-none collapsed" type="button"
                data-bs-toggle="collapse" data-bs-target="#filter-collapseYear" aria-expanded="true"
                aria-controls="filter-collapseYear">
                <span class="text-uppercase fs-12 fw-medium">
                  {{ 't-m-properties.t-year-of-construction' | translate }}
                </span>
              </button>
            </h2>

            <div id="filter-collapseYear" class="accordion-collapse collapse " aria-labelledby="filter-year">
              <div class="accordion-body text-body pt-0">

                <div class="formCost d-flex gap-2 align-items-center mt-3">
                  <input class="form-control form-control-sm" type="number" id="minYearofconstructionInput"
                    placeholder="Min" formControlName="minYearofconstruction" (blur)="touch($event)">
                  <span class="fw-semibold text-muted">
                    {{ 't-range-to' | translate }}
                  </span>
                  <input class="form-control form-control-sm" type="number" id="maxYearofconstructionInput"
                    placeholder="Max" formControlName="maxYearofconstruction" (blur)="touch($event)">
                </div>
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <h2 class="accordion-header" id="filter-validated-at">
              <button class="accordion-button bg-transparent shadow-none collapsed" type="button"
                data-bs-toggle="collapse" data-bs-target="#filter-collapseValidatedAt" aria-expanded="true"
                aria-controls="filter-collapseValidatedAt">
                <span class="text-uppercase fs-12 fw-medium">
                  {{ 't-property-validation-date' | translate }}
                </span>
              </button>
            </h2>

            <div id="filter-collapseValidatedAt" class="accordion-collapse collapse "
              aria-labelledby="filter-validated-at">
              <div class="accordion-body text-body pt-0">
                <div class="formCost d-flex gap-2 align-items-center mt-3">
                  <input class="form-control form-control-sm" type="date" id="minValidatedAtInput"
                    formControlName="minValidatedAt">
                  <span class="fw-semibold text-muted">
                    {{ 't-range-to' | translate }}
                  </span>
                  <input class="form-control form-control-sm" type="date" id="maxValidatedAtInput"
                    formControlName="maxValidatedAt">
                </div>
              </div>
            </div>
          </div>

          <div class="accordion-item">
            <h2 class="accordion-header" id="filter-created-at">
              <button class="accordion-button bg-transparent shadow-none collapsed" type="button"
                data-bs-toggle="collapse" data-bs-target="#filter-collapseCreatedAt" aria-expanded="true"
                aria-controls="filter-collapseCreatedAt">
                <span class="text-uppercase fs-12 fw-medium">
                  {{ 't-created-at' | translate }}
                </span>
              </button>
            </h2>

            <div id="filter-collapseCreatedAt" class="accordion-collapse collapse " aria-labelledby="filter-created-at">
              <div class="accordion-body text-body pt-0">
                <div class="formCost d-flex gap-2 align-items-center mt-3">
                  <input class="form-control form-control-sm" type="date" id="minCreatedAtInput"
                    formControlName="minCreatedAt">
                  <span class="fw-semibold text-muted">
                    {{ 't-range-to' | translate }}
                  </span>
                  <input class="form-control form-control-sm" type="date" id="maxCreatedAtInput"
                    formControlName="maxCreatedAt">
                </div>
              </div>
            </div>
          </div>

          <div class="accordion-item">
            <h2 class="accordion-header" id="filter-updated-at">
              <button class="accordion-button bg-transparent shadow-none collapsed" type="button"
                data-bs-toggle="collapse" data-bs-target="#filter-collapseUpdatedAt" aria-expanded="true"
                aria-controls="filter-collapseUpdatedAt">
                <span class="text-uppercase fs-12 fw-medium">
                  {{ 't-m-properties.t-updated-at' | translate }}
                </span>
              </button>
            </h2>

            <div id="filter-collapseUpdatedAt" class="accordion-collapse collapse " aria-labelledby="filter-updated-at">
              <div class="accordion-body text-body pt-0">
                <div class="formCost d-flex gap-2 align-items-center mt-3">
                  <input class="form-control form-control-sm" type="date" id="minUpdatedAtInput"
                    formControlName="minUpdatedAt">
                  <span class="fw-semibold text-muted">
                    {{ 't-range-to' | translate }}
                  </span>
                  <input class="form-control form-control-sm" type="date" id="maxUpdatedAtInput"
                    formControlName="maxUpdatedAt">
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </form>
  </div>
  <!--end offcanvas-body-->

  <div class="offcanvas-footer border-top p-3 text-center hstack gap-2">
    <button class="btn btn-light w-100" (click)="resetPropertiesFiltersForm()">
      {{ 't-clear-filter'| translate }}
    </button>
    <button type="submit" class="btn btn-outline-primary btn-label waves-effect waves-light w-100"
      (click)="filtersProperties();" [ngClass]="{'btn-load':isCountPropertyFilters}">
      <i class="ri-search-line label-icon align-middle fs-16 me-2"></i>
      <ng-container *ngIf="!isCountPropertyFilters">
        {{totalPropertyFilters}} {{ 't-properties'| translate }}
      </ng-container>

      <span class="d-flex align-items-center" *ngIf="isCountPropertyFilters">
        <span class="spinner-border flex-shrink-0" role="status">
          <span class="visually-hidden"> {{ 't-loading'| translate }}...</span>
        </span>
        <span class="flex-grow-1 ms-2">
          {{ 't-loading'| translate }}...
        </span>
      </span>
    </button>
  </div>
  <!--end offcanvas-footer-->
</div>

<div (click)="closeCanvas(null, true)" class="offcanvas-backdrop fade show"
  *ngIf="showPropertyFilerts && nabTabActive === 1"></div>

<app-toasts-header-be [title]="toastsTitle" [text]="toastsText" [percentage]="toastsPercentage"
  (toastClosed)="toastClosed()" *ngIf="showToasts"></app-toasts-header-be>

<!-- modal preview -->
<ng-template let-modal #modalPreview>
  <div class="modal-header border-bottom rounded p-3 gap-2">
    <div class="d-flex flex-wrap align-items-center gap-2 preview-header-main">
      <h5 *ngIf="propertyToPreview && propertyToPreview?.title" class="modal-title" id="userModalLabel">
        {{'t-property-details' | translate}}
      </h5>
      <span class="badge badge-soft-primary fs-13">Ref: {{propertyToPreview.reference}}</span>

      <div
        *ngIf="showcaseLayouts && showcaseLayouts!.length > 0 && (permissionsService.checkAgentPermission(fullPropertyToPreview?.mainAgent, 'EDIT_PROPERTIES') || permissionsService.canEditProperty(loginUser, fullPropertyToPreview?.store?.id))"
        class="badge badge-soft-primary fs-13 cursor-pointer" (click)="OpenModalMontra(propertyToPreview)">
        {{'t-showcase-sheet' | translate}}
      </div>

    </div>
    <button type="button" class="btn-close" aria-label="Close" id="close-modal" (click)="modal.dismiss('Cross click')">
    </button>
  </div>
  <div class="modal-body p-0">
    <div class="mx-0 row">
      <div class="border-end col-md-6 p-3 preview-main-col">
        <!-- Tocar na imagem abre-a inteira; deslizar muda de imagem (telemóvel). -->
        <div class="preview-gallery" (touchstart)="onPreviewTouchStart($event)"
          (touchend)="onPreviewTouchEnd($event, carouselPreview)">
          <ngb-carousel [activeId]="activeSliderId" #carouselPreview (slide)="onPreviewSlide($event)">
            <ng-template *ngFor="let image of propertyToPreview?.images; let i = index" ngbSlide [id]="'ngb-slide-' + i">
              <div class="picsum-img-wrapper position-relative">
                <img [src]="pathImage + image?.url" class="w-100 mh-5 preview-gallery-img" [alt]="image?.description || ''"
                  (click)="openPreviewImage(i)" />
                <span class="badge preview-gallery-counter">{{ i + 1 }} / {{ propertyToPreview?.images?.length }}</span>
                <button type="button" class="btn btn-sm btn-light btn-icon preview-gallery-expand"
                  [attr.aria-label]="'t-crop-zoom-in' | translate" (click)="openPreviewImage(i)">
                  <i class="ri-fullscreen-line fs-16"></i>
                </button>
              </div>
              <div *ngIf="image?.description" class="carousel-caption">
                <h3 class="text-white">{{image?.description}}</h3>
              </div>
            </ng-template>
          </ngb-carousel>
        </div>
        <div class="details mt-3">
          <h3 class="text-black preview-title">{{propertyToPreview.title}}</h3>
          <div class="d-flex flex-wrap align-items-center justify-content-between gap-2">
            <h3 class="fw-bold mb-0 text-primary preview-price" *ngIf="propertyToPreview.price">
              {{priceFormat(propertyToPreview.price)}}</h3>
            <div class="d-flex flex-wrap align-items-center gap-2">
              <span *ngIf="propertyToPreview.exclusive" class="badge badge-soft-success fs-14">{{'t-exclusive' |
                translate}}</span>
              <span *ngIf="propertyToPreview.isResale" class="badge badge-soft-warning fs-14">{{
                propertyToPreview.resaleOf?.reference
                  ? ('t-resale-of' | translate:{ reference: propertyToPreview.resaleOf?.reference })
                  : ('t-resale' | translate) }}</span>
              <span *ngIf="propertyToPreview.businessType"
                class="badge badge-soft-primary fs-14">{{propertyToPreview.businessType}}</span>
            </div>
          </div>
        </div>
        <div class="preview-divisions mt-3">
          <div *ngIf="propertyToPreview.bedrooms" class="division-prev border p-2">
            <i class="mdi mdi-bed fs-1 text-primary"></i>
            <span class="text-muted">{{'t-mls-filters.t-bedrooms' | translate}}</span>
            {{propertyToPreview.bedrooms}}
          </div>
          <div *ngIf="propertyToPreview.bathrooms" class="division-prev border p-2">
            <i class="mdi mdi-bathtub fs-1 text-primary"></i>
            <span class="text-muted">{{'t-mls-filters.t-bathrooms' | translate}}</span>
            {{propertyToPreview.bathrooms}}
          </div>
          <div *ngIf="propertyToPreview.usefulArea" class="division-prev border p-2">
            <i class="mdi mdi-ruler-square fs-1 text-primary"></i>
            <span class="text-muted">{{'t-m-properties.t-useful-area' | translate}}</span>
            {{propertyToPreview.usefulArea}} m²
          </div>
        </div>
        <div *ngIf="propertyToPreview.description" class="mt-3 preview-description">
          <h4 class="text-black fs-5">{{'t-description' | translate}}:</h4>
          <ngx-simplebar class="px-3 mx-n3 mb-2" style="max-height: 200px;">
            <p [innerHTML]="propertyToPreview.description"></p>
          </ngx-simplebar>
        </div>
      </div>
      <div class="col-md-6 p-3 rsi preview-info">
        <h4 class=" d-flex align-items-center"><i class="mdi mdi-information text-primary"></i>
          {{'t-property-preview.t-info' | translate}}</h4>
        <div class="row g-2 mt-3">
          <div *ngIf="propertyToPreview.propertyType && propertyToPreview.propertyType !== '---'" class="col-md-6">
            <div class="p-2 border-bottom d-flex justify-content-between align-items-center">
              <span class="text-muted">{{'t-m-properties.t-property-type' | translate}}: </span>
              <span>{{propertyToPreview.propertyType}}</span>
            </div>
          </div>
          <div *ngIf="propertyToPreview.condition && propertyToPreview.condition !== '---'" class="col-md-6">
            <div class="p-2 border-bottom d-flex justify-content-between align-items-center">
              <span class="text-muted">{{'t-m-properties.t-status' | translate}}: </span>
              <span>{{propertyToPreview.condition}}</span>
            </div>
          </div>
          <div *ngIf="propertyToPreview.yearOfConstruction" class="col-md-6">
            <div class="p-2 border-bottom d-flex justify-content-between align-items-center">
              <span class="text-muted">{{'t-m-properties.t-year-of-construction' | translate}}: </span>
              <span>{{propertyToPreview.yearOfConstruction | date: 'yyyy'}}</span>
            </div>
          </div>
          <div *ngIf="propertyToPreview.grossArea" class="col-md-6">
            <div class="p-2 border-bottom d-flex justify-content-between align-items-center">
              <span class="text-muted">{{'t-m-properties.t-gross-area' | translate}}: </span>
              <span>{{propertyToPreview.grossArea}} m²</span>
            </div>
          </div>
          <div *ngIf="propertyToPreview.ec" class="col-md-6">
            <div class="p-2 border-bottom d-flex justify-content-between align-items-center">
              <span class="text-muted">{{'t-m-properties.t-energetic-certification' | translate}}: </span>
              <span>{{propertyToPreview.ec}}</span>
            </div>
          </div>
          <div *ngIf="propertyToPreview.createdAt" class="col-md-6">
            <div class="p-2 border-bottom d-flex justify-content-between align-items-center">
              <span class="text-muted">{{'t-created-at' | translate}}: </span>
              <span>{{propertyToPreview.createdAt | date: 'dd/MM/yyyy'}}</span>
            </div>
          </div>
        </div>
        <h4 class="mt-3 d-flex align-items-center"><i class="mdi mdi-map-marker text-primary"></i>
          {{'t-m-properties.t-location' | translate}}
        </h4>
        <div class="row g-2 mt-3">
          <div *ngIf="propertyToPreview.district && propertyToPreview.district !== '---'" class="col-12">
            <div class="p-2 border-bottom d-flex justify-content-between align-items-center">
              <span class="text-muted">{{'t-m-properties.t-district' | translate}}: </span>
              <span>{{propertyToPreview.district}}</span>
            </div>
          </div>
          <div *ngIf="propertyToPreview.county && propertyToPreview.county !== '---'" class="col-12">
            <div class="p-2 border-bottom d-flex justify-content-between align-items-center">
              <span class="text-muted">{{'t-m-properties.t-county' | translate}}: </span>
              <span>{{propertyToPreview.county}}</span>
            </div>
          </div>
          <div *ngIf="propertyToPreview.parish && propertyToPreview.parish !== '---'" class="col-12">
            <div class="p-2 border-bottom d-flex justify-content-between align-items-center">
              <span class="text-muted">{{'t-m-properties.t-parish' | translate}}: </span>
              <span>{{propertyToPreview.parish}}</span>
            </div>
          </div>
          <div *ngIf="propertyToPreview.zone" class="col-12">
            <div class="p-2 border-bottom d-flex justify-content-between align-items-center">
              <span class="text-muted">{{'t-m-properties.t-zone' | translate}}: </span>
              <span>{{propertyToPreview.zone}}</span>
            </div>
          </div>
        </div>
        <!-- <h4
          *ngIf="propertyToPreview.owner && permissionsService.canEditProperty(loginUser, fullPropertyToPreview?.store?.id)"
          class="mt-3 d-flex align-items-center"><i class="mdi mdi-account-box text-primary"></i>
          {{'t-lead-owner' | translate}}</h4>
        <div
          *ngIf="propertyToPreview.owner && permissionsService.canEditProperty(loginUser, fullPropertyToPreview?.store?.id)"
          class="row g-2 mt-3">
          <div *ngIf="propertyToPreview.owner?.name" class="col-12">
            <div class="p-2 border-bottom d-flex justify-content-between align-items-center">
              <span class="text-muted">{{'t-name' | translate}}: </span>
              <span>{{propertyToPreview.owner?.name}}</span>
            </div>
          </div>
          <div *ngIf="propertyToPreview.owner?.phone" class="col-12">
            <div class="p-2 border-bottom d-flex justify-content-between align-items-center">
              <span class="text-muted">{{'t-phone' | translate}}: </span>
              <span>{{propertyToPreview.owner?.phone}}</span>
            </div>
          </div>
          <div *ngIf="propertyToPreview.owner?.email" class="col-12">
            <div class="p-2 border-bottom d-flex justify-content-between align-items-center">
              <span class="text-muted">{{'t-email' | translate}}: </span>
              <span>{{propertyToPreview.owner?.email}}</span>
            </div>
          </div>
        </div> -->
        <h4 *ngIf="propertyToPreview.portals && propertyToPreview.portals.length > 0"
          class="mt-3 d-flex align-items-center">
          <i class="mdi mdi-web text-primary"></i>
          {{'t-portals' | translate}}
        </h4>
        <div *ngIf="propertyToPreview.portals && propertyToPreview.portals.length > 0" class="row g-2 mt-3">
          <div *ngFor="let portal of propertyToPreview.portals" class="col-12">
            <div [ngClass]="portal?.status === true ? 'bg-custom-soft-success' : 'bg-custom-soft-danger'"
              class="p-2 border d-flex justify-content-between align-items-center">
              <span class="text-black">{{portal?.name}} </span>
              <i *ngIf="portal?.status === true" class="mdi mdi-check-circle text-success fs-20"></i>
              <i *ngIf="portal?.status === false" class="mdi mdi-close-circle text-danger fs-20"></i>
            </div>
          </div>
        </div>

        <div *ngIf="enablePropertyNotes && propertyNotesAccess?.canRead" class="mt-3">
          <button type="button" class="btn w-100 d-flex justify-content-between align-items-center px-0"
            (click)="togglePropertyNotes()">
            <span>{{'t-view-notes' | translate}}</span>
            <i class="mdi fs-5" [ngClass]="propertyNotesExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'"></i>
          </button>

          <div *ngIf="propertyNotesExpanded" class="border rounded mt-2 p-3">
            <ng-container *ngIf="propertyNotesAccess?.canWrite">
              <label class="form-label fw-semibold">{{ 't-property-notes-new-note' | translate }}</label>
              <textarea class="form-control" rows="3" [placeholder]="'t-property-notes-placeholder' | translate"
                [value]="newPropertyNote" (input)="newPropertyNote = $any($event.target).value"></textarea>
              <div class="mt-2">
                <input #propertyNotesFileInput type="file" class="form-control form-control-sm" multiple
                  (change)="onPropertyNoteFilesSelected($event)">
                <small class="text-muted" *ngIf="propertyNoteFilesToUpload.length > 0">
                  {{ 't-property-notes-files-selected' | translate:{ count: propertyNoteFilesToUpload.length } }}
                </small>
              </div>
              <div class="d-flex justify-content-end mt-2">
                <button type="button" class="btn btn-sm btn-primary"
                  [disabled]="propertyNotesSaving || (!newPropertyNote?.trim() && propertyNoteFilesToUpload.length === 0)"
                  (click)="addPropertyNote()">
                  <span *ngIf="!propertyNotesSaving">{{ 't-property-notes-add-note' | translate }}</span>
                  <span *ngIf="propertyNotesSaving">
                    <span class="spinner-border spinner-border-sm me-1" role="status"></span>
                    {{ 't-property-notes-saving' | translate }}
                  </span>
                </button>
              </div>
            </ng-container>

            <div class="mt-3" *ngIf="propertyNotesLoading">
              <div class="d-flex justify-content-center">
                <div class="spinner-border text-primary" role="status"></div>
              </div>
            </div>

            <div class="mt-3" *ngIf="!propertyNotesLoading && propertyNotes.length === 0">
              <small class="text-muted">{{ 't-property-notes-empty' | translate }}</small>
            </div>

            <div class="mt-3" *ngIf="!propertyNotesLoading && propertyNotes.length > 0"
              style="max-height: 260px; overflow-y: auto;">
              <div *ngFor="let note of propertyNotes" class="border rounded p-2 mb-2">
                <div class="d-flex justify-content-between mb-1">
                  <small class="fw-semibold">{{ note?.createdByName || note?.createdBy || '-' }}</small>
                  <small class="text-muted">{{ formatPropertyNoteDate(note?.createdAt) }}</small>
                </div>
                <div class="mb-1">{{ note?.description || '-' }}</div>
                <div *ngIf="note?.files?.length > 0" class="d-flex flex-column gap-1 mt-2">
                  <a *ngFor="let file of note.files" [href]="getPropertyNoteFileUrl(note, file)" target="_blank"
                    rel="noopener noreferrer" class="text-decoration-none">
                    <i class="mdi mdi-paperclip"></i>
                    <small>{{ file?.originalName || file?.fileName }}</small>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <h4 *ngIf="propertyToPreview.documents && propertyToPreview.documents.length > 0"
          class="mt-3 d-flex align-items-center">
          <i class="mdi mdi-file-sign text-primary"></i>
          {{'t-m-properties.t-documents' | translate}}
        </h4>

        <div
          *ngIf="propertyToPreview.documents && propertyToPreview.documents.length > 0 && (permissionsService.canEditProperty(loginUser, fullPropertyToPreview?.store?.id) || permissionsService.hasEntityDataScope('PROPERTY_DOCUMENTS'))"
          class="row g-2 mt-3">
          <div *ngFor="let doc of propertyToPreview.documents" class="col-12">
            <div class="p-2 border d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center">
                <i class="mdi mdi-file-document text-success fs-20"></i>
                <span class="text-black ms-2">{{doc.description}} </span>
              </div>
              <div class="d-flex align-items-center gap-2">
                <a href="{{pathDocuments + doc.url}}" target="_blank"><i
                    class="mdi mdi-download text-success fs-20"></i></a>
                <a href="{{pathDocuments + doc.url}}/preview" target="_blank"><i
                    class="mdi mdi-eye-outline text-success fs-20"></i></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer justify-content-between align-items-center gap-2">
    <div class="status-prev d-flex align-items-center gap-1">
      <span class="rounded-circle" [ngClass]="{
      'bg-success': propertyToPreview.businessStatus?.code === 'AVAILABLE',
      'bg-warning': ['PROSPECTING', 'TO_VALIDATE', 'CPCV', 'DEED', 'NO_ATTENTION'].includes(propertyToPreview.businessStatus?.code),
      'bg-info': ['RENTED', 'RESERVED', 'LEASED'].includes(propertyToPreview.businessStatus?.code),
      'bg-danger': ['CANCELED', 'REMOVED', 'DECLINED', 'SOLD'].includes(propertyToPreview.businessStatus?.code)
    }"></span><span>{{ propertyToPreview.businessStatus?.name }}</span>
    </div>
    <button *ngIf="(!openPreview || allowEditFromEmbeddedPreview) && !permissionsService.isReadOnly" (click)="editPropertyByPreview(); modal.dismiss()"
      type="button" class="btn btn-primary">{{'t-m-properties.t-edit-property' | translate}}</button>
  </div>
</ng-template>

<ng-template let-modal #modalMontra>
  <div class="modal-header bg-primary bg-primary-contacts border-bottom rounded p-3">
    <div class="d-flex align-items-center gap-2">
      <h5 *ngIf="propertyToPreview && propertyToPreview?.title" class="modal-title text-white" id="userModalLabel">
        {{'t-showcase-sheet' | translate}}
      </h5>
    </div>
    <button type="button" class="btn-close text-white white" aria-label="Close" id="close-modal"
      (click)="modal.dismiss('Cross click'); closeModalMontra()">
    </button>
  </div>
  <div class="modal-body p-0 showcase-modal">
    <div class="showcase-grid">
      <form [formGroup]="montraForm" class="showcase-panel showcase-panel-form">
        <div class="showcase-section-title">{{'t-showcase-layouts.t-sheet-data' | translate}}</div>
        <p class="showcase-section-hint mb-3">
          {{'t-showcase-layouts.t-required-fields-hint' | translate}}
        </p>

        <div class="mb-3">
          <label class="form-label mb-2">{{'t-showcase-layouts.t-layout' | translate}}</label>
          <div *ngIf="showcaseLayoutsLoading" class="text-muted small">
            {{'t-loading' | translate}}...
          </div>
          <div *ngIf="!showcaseLayoutsLoading && showcaseLayouts.length === 0" class="alert alert-light border">
            {{'t-showcase-layouts.t-no-entity-layouts' | translate}}
          </div>
          <div class="showcase-layout-options" *ngIf="!showcaseLayoutsLoading && showcaseLayouts.length > 0">
            <button type="button" class="showcase-layout-option" *ngFor="let layout of showcaseLayouts"
              [class.selected]="selectedShowcaseLayout?.code === layout.code" (click)="selectShowcaseLayout(layout)">
              <div class="showcase-layout-option-preview" [class.has-image]="buildShowcasePreviewUrl(layout)"
                (click)="openShowcaseLayoutPreview($event, layout)">
                <img *ngIf="buildShowcasePreviewUrl(layout)" [src]="buildShowcasePreviewUrl(layout)!"
                  [alt]="'t-showcase-layouts.t-preview-layout' | translate">
                <div *ngIf="buildShowcasePreviewUrl(layout)" class="showcase-layout-option-preview-action"
                  [attr.aria-label]="('t-showcase-layouts.t-preview-full' | translate)">
                  <i class="ri-search-eye-line"></i>
                </div>
                <span *ngIf="!buildShowcasePreviewUrl(layout)">{{ (layout.format === 'VERTICAL' ?
                  't-showcase-layouts.t-orientation-vertical' : 't-showcase-layouts.t-orientation-horizontal') |
                  translate }}</span>
              </div>
              <div class="showcase-layout-option-text">
                <strong>{{ layout.name }}</strong>
                <small>{{ getShowcaseImagesRangeLabel(layout.minImages, layout.maxImages) }}</small>
              </div>
            </button>
          </div>
        </div>

        <div class="mb-2">
          <label class="form-label mb-1">{{'t-title' | translate}} <span class="required-mark"
              *ngIf="selectedShowcaseLayout?.hasTitle !== false">*</span></label>
          <input type="text" class="form-control" [attr.maxlength]="selectedShowcaseLayout?.titleMaxLength || null"
            formControlName="title"
            [class.is-invalid]="montraForm.get('title')?.invalid && montraForm.get('title')?.touched">
          <div *ngIf="montraForm.get('title')?.invalid && montraForm.get('title')?.touched"
            class="invalid-feedback d-block">
            {{'t-showcase-layouts.t-title-required' | translate}}
          </div>
          <small class="text-muted">{{ montraForm.get('title')?.value?.length || 0 }}/{{
            selectedShowcaseLayout?.titleMaxLength || '-' }}</small>
        </div>

        <div class="mb-2" *ngIf="selectedShowcaseLayout?.hasSubTitle !== false">
          <label class="form-label mb-1">{{'t-showcase-layouts.t-subtitle' | translate}}</label>
          <input type="text" class="form-control" [attr.maxlength]="selectedShowcaseLayout?.subTitleMaxLength || null"
            formControlName="subTitle"
            [class.is-invalid]="montraForm.get('subTitle')?.invalid && montraForm.get('subTitle')?.touched">
          <small class="text-muted">{{ montraForm.get('subTitle')?.value?.length || 0 }}/{{
            selectedShowcaseLayout?.subTitleMaxLength || '-' }}</small>
        </div>

        <div class="mb-2">
          <label class="form-label mb-1">{{'t-showcase-layouts.t-zone' | translate}}</label>
          <input type="text" class="form-control" [attr.maxlength]="selectedShowcaseLayout?.zoneMaxLength || null"
            formControlName="zone"
            [class.is-invalid]="montraForm.get('zone')?.invalid && montraForm.get('zone')?.touched">
          <small class="text-muted">{{ montraForm.get('zone')?.value?.length || 0 }}/{{
            selectedShowcaseLayout?.zoneMaxLength || '-' }}</small>
        </div>

        <div class="mb-2">
          <label class="form-label mb-1">{{'t-description' | translate}} <span class="required-mark">*</span></label>
          <textarea [attr.maxlength]="selectedShowcaseLayout?.descriptionMaxLength || null"
            formControlName="description" class="form-control" rows="6"
            [class.is-invalid]="montraForm.get('description')?.invalid && montraForm.get('description')?.touched"></textarea>
          <div *ngIf="montraForm.get('description')?.invalid && montraForm.get('description')?.touched"
            class="invalid-feedback d-block">
            {{'t-showcase-layouts.t-description-required' | translate}}
          </div>
          <small class="text-muted">{{ montraForm.get('description')?.value?.length || 0 }}/{{
            selectedShowcaseLayout?.descriptionMaxLength || '-' }}</small>
        </div>
      </form>

      <div class="showcase-panel showcase-panel-images">
        <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-1">
          <label class="form-label mb-0">
            {{'t-showcase-layouts.t-images' | translate}} <span class="required-mark">*</span>
          </label>
          <span class="showcase-count-badge" [class.invalid]="!hasValidShowcaseImageCount">
            {{ selectedShowcaseImagesCount }}/{{ showcaseMaxImages }}
          </span>
        </div>
        <p class="showcase-section-hint mb-3">
          {{ getSelectedShowcaseImagesHint() }}
        </p>

        <div class="row g-2 div-images">
          <div class="col-6" *ngFor="let img of propertyToPreview?.images">
            <button type="button" class="showcase-image-card" [class.selected]="isImageSelected(img)"
              (click)="toggleImageSelection(img)">
              <img [src]="pathImage + img.url" class="showcase-image-preview"
                [alt]="'t-showcase-layouts.t-property-image' | translate">
              <div class="showcase-image-meta">
                <input type="checkbox" [checked]="isImageSelected(img)" (click)="$event.stopPropagation()"
                  (change)="toggleImage(img, $event)">
                <small>{{ (isImageSelected(img)
                  ? 't-showcase-layouts.t-selected'
                  : 't-showcase-layouts.t-select') | translate }}</small>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer justify-content-end align-items-center">
    <button *ngIf="!openPreview " (click)="saveMontra()" type="button" class="btn btn-primary"
      [disabled]="!canGenerateShowcase">
      <span *ngIf="!isLoadingShowcase">{{'t-generate' |
        translate}}</span>
      <span class="d-flex justify-content-center align-items-center" *ngIf="isLoadingShowcase">
        <span class="me-2">
          {{'t-generating' | translate}}...
        </span>
        <span class="spinner-border spinner-border-sm flex-shrink-0" role="status">
          <span class="visually-hidden">{{'t-generating' | translate}}...</span>
        </span>
      </span></button>
  </div>
</ng-template>

<!-- <app-showcase-sheet></app-showcase-sheet> -->
